import { Grid, Typography } from "@mui/material";
import { PersonIdTypes } from "utils/choices";
import { doctoralSeatLabel } from "../../seatLabel";

const LabeledValue = ({ label, value }) => (
  <Grid item xs={12} md={4}>
    <Typography variant="caption" color="textSecondary" display="block">
      {label}
    </Typography>
    <Typography>{value || "—"}</Typography>
  </Grid>
);

const ReadOnlySection = ({ data }) => {
  const personIdTypeName = PersonIdTypes.find(t => t.id === data?.candidate?.personIdType)?.name;

  return (
    <Grid container spacing={2}>
      <LabeledValue label="Вх. номер" value={data?.registrationNumber} />
      <LabeledValue label={personIdTypeName || "Идентификатор"} value={data?.candidate?.personId} />
      <LabeledValue label="Имейл (потребителско име)" value={data?.email} />
      {data?.externalEmail && <LabeledValue label="Университетски имейл" value={data.externalEmail} />}
      <LabeledValue label="Докторантска програма" value={data?.seat?.doctoralProgramNameBg} />
      <LabeledValue label="Програма / форма на обучение" value={doctoralSeatLabel(data?.seat)} />
    </Grid>
  );
};

export default ReadOnlySection;
